import React, { useEffect, useRef, useState } from 'react'
import styles from "./Toppanel.module.css"
import styles1 from "../pages/Dashboardcomponents/Environmentpanel.module.css"
import { Link } from 'react-router-dom'
import { ReactComponent as Icon } from "../Icon/circle-plus.svg"
import { ReactComponent as Icon1 } from "../Icon/createnewfile.svg"
import { ReactComponent as Icon2 } from "../Icon/upload.svg"
import { TbArrowBadgeRightFilled } from "react-icons/tb";
import { create_project_file_Api, delete_project_file_Api, renameProjectFileApi, indexing_Project_File_Api } from '../dashboardapi'
import { IconButton, Button, useToast, Tooltip, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, Box, useDisclosure, Spinner, Flex, Text, VStack } from '@chakra-ui/react'
import CustomModal from "../pages/Dashboardcomponents/Modal"
import { color } from 'framer-motion'
import { useNavigate } from 'react-router-dom'

const Toppanel = (props) => {
    const [filetodelete, setFiletoDelete] = useState("")
    const [groupfiles, setGroupFiles] = useState("");
    const fileInputRef = useRef(null);
    const [openGroups, setOpenGroups] = useState({ tex: [] });
    const [renamingFile, setRenamingFile] = useState(null);
    const [newFileName, setNewFileName] = useState("");
    const [contextMenu, setContextMenu] = useState(null);
    const [fileUploadShow, setFileUploadShow] = useState(false);
    const [dragging, setDragging] = useState(false);
    const [projectFiles, setProjectFiles] = useState([]);
    const [uploading, setUploading] = useState(null);
    const [showMore, setShowMore] = useState(false);
    const [currentFileIndex, setCurrentFileIndex] = useState(-1);

    const [indexFile, setIndexFile] = useState("");
    const [indexRes, setIndexRes] = useState();
    // const [name, setName] = useState([]);
    const toast = useToast();
    const moreref = useRef();
    const navigate = useNavigate();


    useEffect(() => {
        const moreClick = (e) => {
            if (moreref.current && !moreref.current.contains(e.target) && !e.target.closest(".morebtn")) {
                setCurrentFileIndex(-1);
            }
        }

        document.addEventListener("click", moreClick);
        return () => document.removeEventListener("click", moreClick)
    })


    const {
        isOpen: alertOpen,
        onToggle: onalertToogle,
        onClose: onalertClose,
    } = useDisclosure();

    //MARK:Handle upload
    const handleFiles = async (files) => {
        const fileslist = Array.from(files);
        if (!fileslist.length) return;

        // Store first selected file for preview
        setProjectFiles(fileslist);//state
        setFileUploadShow(true);//state
    }

    const handleUpload = async () => {
        if (!projectFiles.length) {
            toast({
                title: "No files selected",
                description: "Please choose a file to upload.",
                status: "warning",
                duration: 2000,
                isClosable: true,
            });
            return;
        }
        setUploading(true);//state
        toast({
            title: "Uploading...",
            description: `Uploading ${projectFiles.length} file(s)`,
            status: "loading",
            isClosable: true,
        });
        try {
            const result = await create_project_file_Api(props.projectid, projectFiles);
            toast.closeAll();
            setUploading(false);

            if (result.data) {
                toast({
                    title: "Upload successful",
                    description: `${projectFiles.name} uploaded successfully.`,
                    status: "success",
                    duration: 2000,
                    isClosable: true,
                });
                props.getprojectfiles();
                setProjectFiles([]);
                setFileUploadShow(false);
            } else {
                const error = result.error?.message || "Upload failed.";
                toast({
                    title: "Upload failed",
                    description: error,
                    status: "error",
                    duration: 2000,
                    isClosable: true,
                });
            }
        } catch (error) {
            toast.closeAll();
            setUploading(false);
            toast({
                title: "Error",
                description: error.message || "Something went wrong.",
                status: "error",
                duration: 2000,
                isClosable: true,
            });
        }
    };


    const handleClick = () => {
        // Trigger file input click
        setFileUploadShow(true)
    };

    const triggerInputClick = () => {
        fileInputRef.current.click();
    }

    const handleDragOver = (e) => {
        e.preventDefault();
        setDragging(true); // Highlight the area when dragging files
    };

    const handleDragLeave = () => {
        setDragging(false); // Remove highlight when leaving
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragging(false);
        const files = e.dataTransfer.files;
        handleFiles(files); // only preview
    };

    //MARK:create file
    const createFile = async () => {
        let count = 0;
        let num;
        let regex = /^main(\d+)*\.tex/g
        if (props.projectfiles) {
            props.projectfiles.uploads.forEach(element => {
                let res
                while ((res = regex.exec(element.name)) !== null) {
                    if (res[1] === undefined) {
                        count = 1;

                    } else {
                        num = parseInt(res[1])
                        num = Math.max(num)
                        count = num + 1;
                    }
                }
            }
            )
        }
        let name = `main${count}.tex`

        try {
            // Attempt to create the new file
            let result = await create_project_file_Api(props.projectid, name);
            console.log(result.data);

            if (result.data) {
                toast({
                    title: "File Created",
                    description: "Tex file created successfully",
                    status: "success",
                    duration: 2000,
                    isClosable: "true"

                })
                props.loadProjectDetails();
            } else {
                let error = result.error.Message || "An error occurred";
                toast({
                    title: "Problem creating file",
                    description: error,
                    duration: 2000,
                    isClosable: "true"

                })
            }
        } catch (error) {
            toast({
                title: "Problem creating file",
                description: "tex file not created, try again later.",
                status: 'error',
                duration: 2000,
                isClosable: "true"

            })
        }
    };

    //shortcut for new file creation
    useEffect(() => {
        const handleKeyDown = (e) => {
            if ((e.ctrlKey || e.metaKey) && e.key === "F2") {
                e.preventDefault();
                createFile(); // call the same function used by the button
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [createFile]);

    //MARK:Handle Dlt
    const handleDelete = async (projectid, fileid) => {
        toast({
            title: "Deleting file",
            description: "File deletion in progress",
            status: "loading",
            isClosable: "true"

        })
        try {
            let result = await delete_project_file_Api(projectid, fileid);
            if (result.data) {
                toast.closeAll();
                toast({
                    title: "File Deleted",
                    description: "File deleted Successfully",
                    status: "success",
                    duration: 2000,
                    isClosable: "true"

                })
                props.loadProjectDetails();
            } else {
                let error = result.error.message || "An error occurred";
                toast({
                    title: "Problem creating file",
                    description: error,
                    duration: 2000,
                    isClosable: "true"

                })
            }
        } catch (e) {
            toast({
                title: "Problem deleting file",
                description: "tex file not deleted, try again later.",
                status: 'error',
                duration: 2000,
                isClosable: "true"

            })
        }
    }

    const handleDeleteClick = (items) => {
        setFiletoDelete(items);
        onalertToogle();
    }

    const toggleGroup = (extension) => {
        setOpenGroups(prevState => ({
            ...prevState,
            [extension]: !prevState[extension], // Toggle the open/close state of file groups
        }));

    };

    useEffect(() => {
        if (!props.projectfiles.uploads) {
            console.log("No project files available");
            return; // Or return a loading state
        }
        console.log(props.projectfiles.uploads);

        const group = props.projectfiles.uploads?.reduce((groups, file) => {
            const extension = file.name.split(".").pop()
            if (!groups[extension]) groups[extension] = [];
            groups[extension].push(file);
            return groups;
        }, {});

        const preferredOrder = ["tex", "bib", "jpg", "jpeg", "png", "eps", "pdf"];

        let sorted_group = Object.entries(group).sort((a, b) => {
            let typea = preferredOrder.indexOf(a[0]);
            let typeb = preferredOrder.indexOf(b[0]);
            if (typea !== -1 && typeb !== -1) {
                return typea - typeb;
            }
            if (typea !== -1) return -1;
            if (typeb !== -1) return 1;
            return a[0].localeCompare(b[0])
        })
        setGroupFiles(sorted_group);

    }, [props.projectfiles])

    // console.log(groupfiles);


    // const handleRightClick = (e, items) => {
    //     e.preventDefault();
    //     setContextMenu({ x: e.pageX, y: e.pageY, items });
    // }



    const handleRenameClick = (file) => {
        setRenamingFile(file.name);
        setNewFileName(file.name);
    };

    const handleRenameSubmit = (event, file) => {
        event.preventDefault();
        if (newFileName.trim() && newFileName !== file.name) {
            handleRename(file, newFileName);
        }
        setRenamingFile(null);
    };

    const handleRename = async (file, newFileName) => {
        toast({
            title: "Renaming file",
            description: "Please wait..",
            status: 'info',
            isClosable: true,
            icon: (
                <Spinner
                    thickness="4px"
                    emptyColor="gray.200"
                    color="blue.500"
                    size="sm"
                />
            ),
        })
        let response = await renameProjectFileApi(props.projectid, file.uuid, newFileName);
        if (response.data) {
            props.loadProjectDetails();
            toast.closeAll();
        } else {
            toast({
                title: "Problem renaming file",
                description: "There is a problem renaming file please try again later.",
                status: 'error',
                isClosable: true,
                duration: 2000,
            })
        }
    }

    const handleShowMore = (i, items) => {
        if (currentFileIndex !== items.uuid) {
            setCurrentFileIndex(-1)
            setCurrentFileIndex(items.uuid)
        } else {
            setCurrentFileIndex(-1);
        }
    }

    //MARK:Handle indexing
    // const handleIndexing = (file) => {
    //     props.projectfiles[0]
    // }
    const handleIndexing = async (file) => {


        if (!file.name.endsWith(".tex")) {
            toast({
                title: "Indexing Error",
                description: "Only .tex files can be indexed",
                status: "warning",
                duration: 2000,
                isClosable: true,
            });
            return;
        }
        console.log(file);
        setIndexFile(file);
        try {
            const indexed = await indexing_Project_File_Api(props.projectid, file.uuid);
            setIndexRes(indexed);
            console.log(indexed);

            toast({
                title: "File Indexing",
                description: `${file.name} is the index file now`,
                status: "info",
                duration: 2000,
                isClosable: true,
            });

            // setProjectFiles(prev =>prev.map)
        } catch (error) {
            toast({
                title: "Failed to set index file",
                description: error.message || "An unexpected error occurred.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
    }
    useEffect(() => { props.loadProjectDetails() }, [indexFile, indexRes, projectFiles]);

    return (
        <div className={styles.toppanel_outer}>
            <div className={styles.toppanel_header}>
                <Tooltip label={"Create tex file"}>
                    <Box
                        id="newFile"
                        as="button"
                        onClick={createFile}
                        display="flex"
                        alignItems="center"
                        gap="4px"
                    >
                        <Box>
                            <Icon className={styles.create_file} />
                        </Box>
                        <Box>
                            <p style={{ color: "#fff", fontSize: "14px" }}>New File</p>
                        </Box>
                    </Box>
                </Tooltip>
                <hr style={{ height: "50%", width: "2px", background: "#D9D9D9", opacity: "50%" }}></hr>
                <Tooltip label={"Import file"}>
                    {/* <IconButton colorScheme="#323334" onClick={handleClick} icon={<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16">
                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                    </svg>}>
                    </IconButton> */}
                    <Flex cursor={"pointer"} onClick={handleClick} width={"50%"} gap={"2px"} alignItems={"center"}>
                        <Box>
                            <IconButton className={styles.create_file} colorScheme="#323334" >
                                <Icon2 />
                            </IconButton>
                        </Box>
                        <Box>
                            <p style={{ color: "#fff", fontSize: "14px" }}>Upload</p>
                        </Box>
                    </Flex>
                </Tooltip>
                {/* <input
                    type='file'
                    name='project_name'
                    placeholder='Enter Project Name'
                    ref={fileInputRef}
                    style={{ display: 'none' }} // hide the file input
                    multiple
                    onClick={(e) => e.target.value = ""}
                    onChange={(e) => handleFiles(e.target.files)}
                /> */}
            </div>
            <div className={styles.toppanel_body}>
                <div className={styles.toppanel_content}>
                    {/* {props.projectfiles ? props.projectfiles.map((items, i) => (
                        <div key={i} style={{ width: "100%" }}>
                            <div key={i} style={{ width: "90%", display: 'flex', alignItems: "center", justifyContent: "space-between" }}>
                                <Link reloadDocument={items.name.indexOf(".tex") || items.name.indexOf(".bib") > 0 ? true : false} to={"/" + props.projectid + "/" + items.name} key={i} className={styles.filelist}>
                                    <Tooltip label={items.name.length > 9 ? items.name : ""}>
                                        <div style={{ display: "flex", gap: "5px" }}><div><Icon1 /></div><p className={items.name === props.current_file ? styles.selected : ""}>{items.name.length > 9 ? items.name.slice(0, 9) + "..." : items.name}</p></div>
                                    </Tooltip>
                                </Link>
                                <Tooltip label={"Delete File"}>
                                    <div onClick={() => handleDeleteClick(items)}><button style={{ color: "#cccbd3" }}>X</button></div>
                                </Tooltip>
                            </div>
                        </div>
                    )) : ""} */}
                    {
                        groupfiles && groupfiles?.map((extension, index) => (
                            <div key={index}
                                style={{
                                    color: "#cccbd3",
                                    width: "100%"
                                }}>
                                <div onClick={() => toggleGroup(extension[0])}
                                    style={{
                                        backgroundColor: "#4b4e51",
                                        color: "#cccbd3",
                                        fontWeight: "500",
                                        padding: "3px 10px 3px 10px",
                                        display: "flex",
                                        gap: "10px",
                                        cursor: "pointer"
                                    }}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        style={{
                                            transition: "transform 0.3s ease", // Smooth transition
                                            transform: openGroups[extension[0]] ? 'rotate(0deg)' : 'rotate(-90deg)' // Conditional rotation
                                        }}>
                                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                        <path d="M6 9l6 6l6 -6" />
                                    </svg>
                                    <h3>{extension[0].toUpperCase()} Files</h3>
                                </div>
                                {openGroups[extension[0]] &&
                                    extension[1]?.map((items, i) => (
                                        <div key={i} style={{ width: "100%" }}>
                                            <div key={i}
                                                style={{
                                                    width: "90%",
                                                    display: 'flex',
                                                    alignItems: "center",
                                                    justifyContent: "space-between"
                                                }}>
                                                {/* <div style={{ display: "flex", gap: "5px" }}><div><Icon1 /></div><p className={items.name === props.current_file ? styles.selected : ""}>{items.name.length > 9 ? items.name.slice(0, 9) + "..." : items.name}</p></div> */}
                                                {renamingFile === items.name ? (
                                                    <form onSubmit={(e) => handleRenameSubmit(e, items)} className={styles.filelist}>
                                                        <input
                                                            type="text"
                                                            value={newFileName}
                                                            onChange={(e) => setNewFileName(e.target.value)}
                                                            autoFocus
                                                            onBlur={() => setRenamingFile(null)}
                                                            style={{ border: "1px solid #ccc", padding: "2px", borderRadius: "4px", backgroundColor: "#cccbd3", color: "#000" }}
                                                        />
                                                    </form>
                                                ) : (
                                                    <>
                                                        {items.is_index && (
                                                            <TbArrowBadgeRightFilled size={32} color="#f47c0d"
                                                                style={{ display: 'inline-block' }} />
                                                        )}
                                                        <div as="button" onClick={() => {
                                                            if (items.name.endsWith('.tex') || items.name.endsWith('.bib')) {
                                                                navigate(`/${props.projectid}/${items.name}`, { replace: false })
                                                            }
                                                            else if (items.name.endsWith('.png') || items.name.endsWith('.pdf')) {
                                                                toast({
                                                                    title: "Feature to View Upcoming",
                                                                    status: 'error',
                                                                    duration: 2000
                                                                })
                                                            }
                                                            else {
                                                                toast({
                                                                    title: "File Type Error",
                                                                    description: `.${extension[0]} files are not Viewable`,
                                                                    status: 'error',
                                                                    duration: 2000
                                                                })
                                                            }
                                                        }}
                                                            key={i}
                                                            className={styles.filelist}>
                                                            <Tooltip label={items.name}>
                                                                <p className={items.name === props.current_file ? styles.selected : ""}>
                                                                    {items.name}
                                                                </p>
                                                            </Tooltip>
                                                        </div>

                                                        {/* MARK: More button */}

                                                        <div className='morebtn'
                                                            style={{
                                                                height: "auto",
                                                                width: "auto",
                                                                display: 'flex',
                                                                alignItems: "center",
                                                                position: 'relative',
                                                                padding: "5px 10px",
                                                                cursor: 'pointer'
                                                            }}
                                                            onClick={() => handleShowMore(i, items)}>
                                                            <Tooltip label={"More"}> <button style={{ color: "#cccbd3" }}>&#8942;</button></Tooltip>
                                                            {
                                                                currentFileIndex !== -1 && currentFileIndex === items.uuid ? <div ref={moreref} className='more_option'
                                                                    style={{
                                                                        position: "absolute",
                                                                        width: "fit-content",
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        alignItems: 'start',
                                                                        background: "#fff",
                                                                        zIndex: 10000,
                                                                        top: "30px",
                                                                        right: "25px"
                                                                    }}>
                                                                    {(items.name !== "main.tex" && !items.is_index) ?
                                                                        <Button color="#222"
                                                                            borderRadius={0}
                                                                            background="#fff"
                                                                            width={"100%"}
                                                                            padding="5px 10px"
                                                                            textWrap="nowrap"
                                                                            _hover={{ backgroundColor: "blackAlpha.300", color: "#fff" }}
                                                                            onClick={() => { handleIndexing(items) }}
                                                                        >Mark as Index</Button> : ""}

                                                                    <Button width={"100%"}
                                                                        borderRadius={0}
                                                                        color="#222"
                                                                        background="#fff"
                                                                        padding="3px 50px 3px 10px"
                                                                        _hover={{ backgroundColor: "blackAlpha.300", color: "#fff" }}
                                                                        onClick={() => handleRenameClick(items)} >Rename</Button>

                                                                    <Button width={"100%"}
                                                                        borderRadius={0}
                                                                        color="red"
                                                                        background="#fff"
                                                                        padding="3px 55px 10px 8px"
                                                                        _hover={{ backgroundColor: "blackAlpha.300", color: "red" }}
                                                                        onClick={() => handleDeleteClick(items)}>Delete</Button>
                                                                </div> : null
                                                            }
                                                        </div>


                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        ))
                    }
                </div>
                <Modal isOpen={alertOpen} onClose={onalertClose} isCentered>
                    <ModalOverlay >
                        <ModalContent>
                            <ModalHeader>
                                Alert
                            </ModalHeader>
                            <ModalCloseButton />
                            <ModalBody overflow="auto" padding="20px" style={{ borderTop: "1px solid gray" }}>
                                <Box style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                                    <h1 style={{ fontWeight: "500" }}>
                                        {filetodelete.name}
                                    </h1>
                                    <p>
                                        Do you wish to delete the file ?
                                    </p>
                                </Box>
                                <Box mt="15px">
                                    <Button style={{ backgroundColor: "rgba(220,38,38,1)", color: "#fff" }} onClick={() => { handleDelete(props.projectid, filetodelete.uuid); onalertClose() }}> Delete </Button>
                                </Box>
                            </ModalBody>
                        </ModalContent>
                    </ModalOverlay>
                </Modal>
                {/* {contextMenu && (
                    <div
                        style={{
                            position: "absolute",
                            top: contextMenu.y,
                            left: contextMenu.x,
                            background: "#fff",
                            border: "1px solid #ccc",
                            boxShadow: "0px 2px 5px rgba(216, 206, 206, 0.2)",
                            padding: "0 5px",
                            zIndex: 1000,
                        }}
                        onMouseLeave={() => setContextMenu(null)}
                    >
                        <div
                            style={{ fontSize: "14px", padding: "5px", cursor: "pointer" }}
                            onClick={() => handleRenameClick(contextMenu.items)}
                        >
                            Rename
                        </div>
                    </div>
                )} */}
                <CustomModal show={fileUploadShow}>
                    <div className={styles1.modalouter}>
                        <div style={{ display: "flex", flexDirection: "column", width: "100%", padding: "24px" }}>
                            {/* Header */}
                            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "12px" }}>
                                <div className={styles1.modalheader}><p>Upload files</p></div>
                                <button onClick={() => setFileUploadShow(false)} style={{ padding: "5px 10px" }}>
                                    Close
                                </button>
                            </div>

                            {/* Body: Upload and Preview side by side */}
                            <div style={{ display: "flex", gap: "24px" }}>
                                {/* Left: Drop zone */}
                                <div style={{ width: "50%" }}>
                                    <form className={styles1.formouter} method="POST">
                                        <div
                                            className={`${styles1.inputdiv} ${dragging ? styles1.dragging : ''}`}
                                            onDragOver={handleDragOver}
                                            onDragLeave={handleDragLeave}
                                            onDrop={handleDrop}
                                        >
                                            {dragging ? (
                                                <div style={{ height: "133px" }}>Drop your files here</div>
                                            ) : (
                                                <>
                                                    <p>
                                                        {/* <img
                                                            src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/upload_img.png"}
                                                            alt=""
                                                        /> */}
                                                        <svg width="47" height="42" viewBox="0 0 47 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M30.9463 3.77734C31.3003 3.77734 31.5879 4.06488 31.5879 4.41895C31.5879 4.773 31.3004 5.06055 30.9463 5.06055C28.2931 5.06073 25.9029 6.77951 25.0469 9.27051L24.9688 9.51367C24.8781 9.81953 24.5795 10.005 24.2715 9.96387L24.2637 9.97363L24.1719 9.94531C23.8327 9.84417 23.6391 9.4879 23.7402 9.14844C24.6617 6.052 27.5312 3.77753 30.9463 3.77734Z" fill="var(--btn-bg)" stroke="#F9FFF9" stroke-width="0.3" />
                                                            <path d="M37.8229 28.4884H34.8757C34.6045 28.4884 34.3845 28.2684 34.3845 27.9972C34.3845 27.726 34.6045 27.506 34.8757 27.506H37.8229C41.8854 27.506 45.1909 24.2005 45.1909 20.138C45.1909 16.0754 41.8854 12.7699 37.8229 12.7699H37.752C37.6096 12.7699 37.4741 12.7082 37.3808 12.6005C37.2875 12.4928 37.2454 12.35 37.2657 12.2089C37.3096 11.903 37.3317 11.5956 37.3317 11.2963C37.3317 7.77549 34.4669 4.91068 30.946 4.91068C29.5763 4.91068 28.27 5.33873 27.1683 6.14885C26.9262 6.32674 26.5823 6.2478 26.4424 5.98149C23.3222 0.0400754 15.1726 -0.757796 10.9475 4.41072C9.16764 6.58813 8.4683 9.42061 9.02869 12.1812C9.09044 12.4861 8.85711 12.7703 8.54731 12.7703H8.35047C4.28792 12.7703 0.982451 16.0758 0.982451 20.1383C0.982451 24.2009 4.28792 27.5064 8.35047 27.5064H11.2976C11.5689 27.5064 11.7889 27.7263 11.7889 27.9976C11.7889 28.2688 11.5689 28.4888 11.2976 28.4888H8.35047C3.74612 28.4888 0 24.7427 0 20.1383C0 15.6631 3.53873 11.9987 7.96488 11.7966C7.54911 8.93254 8.34416 6.04357 10.1868 3.789C14.7104 -1.74508 23.3796 -1.12478 27.0443 5.04612C28.2134 4.31317 29.5511 3.92867 30.9459 3.92867C35.2116 3.92867 38.5918 7.55937 38.296 11.8012C42.6814 12.0472 46.1731 15.6922 46.1731 20.1379C46.1731 24.7427 42.427 28.4884 37.8227 28.4884L37.8229 28.4884Z" fill="var(--btn-bg)" />
                                                            <path d="M23.0205 14.6895C30.206 14.6895 36.0508 20.5342 36.0508 27.7197C36.0507 34.9051 30.206 40.75 23.0205 40.75C15.8351 40.75 9.99028 34.9053 9.99023 27.7197C9.99023 20.5343 15.8349 14.6895 23.0205 14.6895ZM23.0205 17.1719C17.2053 17.1719 12.4727 21.9046 12.4727 27.7197C12.4727 33.5349 17.2054 38.2676 23.0205 38.2676C28.8356 38.2675 33.5683 33.5348 33.5684 27.7197C33.5684 21.9045 28.8356 17.1719 23.0205 17.1719Z" fill="var(--btn-bg)" stroke="#F9FFF9" stroke-width="1.5" />
                                                            <path d="M23.2444 33.0224C23.0458 33.0224 22.8848 32.8614 22.8848 32.6628V23.3127C22.8848 23.1142 23.0458 22.9531 23.2444 22.9531C23.4429 22.9531 23.604 23.1142 23.604 23.3127V32.6628C23.604 32.8616 23.4429 33.0224 23.2444 33.0224Z" fill="var(--btn-bg)" />
                                                            <path d="M26.1213 26.5503C26.0294 26.5503 25.9371 26.5151 25.867 26.445L23.2444 23.8224L20.6218 26.445C20.4815 26.5855 20.2537 26.5855 20.1132 26.445C19.9727 26.3045 19.9727 26.0769 20.1132 25.9364L22.9901 23.0595C23.1303 22.919 23.3582 22.919 23.4987 23.0595L26.3756 25.9364C26.5161 26.0769 26.5161 26.3045 26.3756 26.445C26.3055 26.5154 26.2132 26.5503 26.1213 26.5503H26.1213Z" fill="var(--btn-bg)" />
                                                        </svg>

                                                    </p>
                                                    <div>Upload your files</div>
                                                    <p>
                                                        Drag and drop your files here or{" "}
                                                        <a onClick={triggerInputClick}>choose files</a>
                                                    </p>
                                                    <input
                                                        type="file"
                                                        ref={fileInputRef}
                                                        style={{ display: "none" }}
                                                        multiple
                                                        onChange={(e) => handleFiles(e.target.files)}
                                                        accept=".txt, .tex, .bib, .pdf, .png, .jpg, .jpeg, .dtx, .ins, .bst, .sty, .eps, .cls"
                                                    />
                                                </>
                                            )}
                                        </div>
                                    </form>
                                </div>

                                {/*MARK:Right Preview in uploads modal box*/}
                                <div style={{ width: "50%", borderLeft: "1px solid var(--border)", paddingLeft: "24px" }}>
                                    {projectFiles.length > 0 ? (
                                        projectFiles?.map((file, i) => (
                                            <Box key={i}
                                                display="flex"
                                                alignItems="flex-start"
                                                justifyContent="space-between"
                                                w="100%"
                                                p={4}
                                                border="1px solid var(--border)"
                                                borderRadius="md"
                                            >
                                                <VStack align="start" spacing={1} w="70%">
                                                    <Text fontSize="md" fontWeight="500" wordBreak="break-word">
                                                        {file.name}
                                                    </Text>
                                                    <Text fontSize="0.75rem" color="var(--text-secondary)">
                                                        {(file.size / 1024).toFixed(2)} KB
                                                    </Text>
                                                </VStack>
                                                <Button variant="ghost" p={0} ml={2} onClick={() => setProjectFiles(projectFiles.filter((_, idx) => idx !== i))}>
                                                    {/* <img
                                                        src="/images/Redesignpics/Dashboard/delete.png"
                                                        alt="delete"
                                                        boxSize="20px"
                                                    /> */}
                                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g clip-path="url(#clip0_45_3546)">
                                                            <path d="M3.33398 5.83301H16.6673" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M8.33398 9.16699V14.167" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M11.666 9.16699V14.167" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M4.16602 5.83301L4.99935 15.833C4.99935 16.275 5.17494 16.699 5.4875 17.0115C5.80006 17.3241 6.22399 17.4997 6.66602 17.4997H13.3327C13.7747 17.4997 14.1986 17.3241 14.5112 17.0115C14.8238 16.699 14.9993 16.275 14.9993 15.833L15.8327 5.83301" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M7.5 5.83333V3.33333C7.5 3.11232 7.5878 2.90036 7.74408 2.74408C7.90036 2.5878 8.11232 2.5 8.33333 2.5H11.6667C11.8877 2.5 12.0996 2.5878 12.2559 2.74408C12.4122 2.90036 12.5 3.11232 12.5 3.33333V5.83333" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_45_3546">
                                                                <rect width="20" height="20" fill="white" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                </Button>
                                            </Box>)
                                        )
                                    ) : (
                                        <Text color="var(--text-secondary)">No file selected</Text>
                                    )}
                                </div>
                            </div>

                            {/* Footer: Common Upload button */}
                            <Box mt={6} display="flex" justifyContent="flex-end">
                                <Button
                                    bg="var(--btn-bg)"
                                    color="var(--btn-text)"
                                    onClick={handleUpload}
                                    isLoading={uploading}
                                    loadingText="Uploading"
                                    _hover={{ bg: "var(--btn-hover)" }}
                                >
                                    Upload
                                </Button>
                            </Box>
                        </div>
                    </div>
                </CustomModal>

            </div>
        </div >
    )
}

export default Toppanel